var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "50%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "400px" } },
        [
          [
            _c(
              "v-stepper",
              {
                model: {
                  value: _vm.currentStep,
                  callback: function ($$v) {
                    _vm.currentStep = $$v
                  },
                  expression: "currentStep",
                },
              },
              [
                _c(
                  "v-stepper-header",
                  [
                    _c(
                      "v-stepper-step",
                      { attrs: { complete: _vm.currentStep > 1, step: "1" } },
                      [
                        _vm._v(
                          _vm._s(this.model == null ? "..." : this.model.id)
                        ),
                      ]
                    ),
                    _c("v-divider"),
                    _c(
                      "v-stepper-step",
                      { attrs: { complete: _vm.currentStep > 2, step: "2" } },
                      [_vm._v("Package Data")]
                    ),
                  ],
                  1
                ),
                _c(
                  "v-stepper-items",
                  [
                    _c(
                      "v-stepper-content",
                      { attrs: { step: "1" } },
                      [
                        _c("p-setup-info", { ref: "p-setup-info" }),
                        _c(
                          "v-card",
                          {
                            staticClass: "ma-0 pa-0 mt-4",
                            attrs: { elevation: "0" },
                          },
                          [
                            _c(
                              "v-card-actions",
                              { staticClass: "ma-0 pa-0" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      disabled: _vm.model == null,
                                      color: "primary",
                                    },
                                    on: { click: _vm.onCompleteInfoStep },
                                  },
                                  [
                                    _vm._v("Continue"),
                                    _c("v-icon", [_vm._v("mdi-chevron-right")]),
                                  ],
                                  1
                                ),
                                _c("v-spacer"),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "white--text",
                                    attrs: { color: "red" },
                                    on: { click: _vm.onClose },
                                  },
                                  [_vm._v("cancel")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-stepper-content",
                      { attrs: { step: "2" } },
                      [
                        _c("p-setup-data", {
                          ref: "p-setup-data",
                          on: {
                            "show-p-file-preview-popup": _vm.onPreviewPackage,
                          },
                        }),
                        _c(
                          "v-card",
                          {
                            staticClass: "ma-0 pa-0 mt-4",
                            attrs: { elevation: "0" },
                          },
                          [
                            _c(
                              "v-card-actions",
                              { staticClass: "ma-0 pa-0" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      disabled: _vm.model == null,
                                      color: "primary",
                                      loading: _vm.saving,
                                    },
                                    on: { click: _vm.onCompleteDataStep },
                                  },
                                  [
                                    _vm._v("DONE"),
                                    _c("v-icon", [_vm._v("mdi-chevron-right")]),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { text: "" },
                                    on: {
                                      click: function ($event) {
                                        _vm.currentStep = 1
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", [_vm._v("mdi-chevron-left")]),
                                    _vm._v("Back"),
                                  ],
                                  1
                                ),
                                _c("v-spacer"),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "white--text",
                                    attrs: { color: "red" },
                                    on: { click: _vm.onClose },
                                  },
                                  [_vm._v("cancel")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }